import { customersApi } from '@/api';

const quarantineFilters = [
  {
    name: 'customerId',
    label: 'customerIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const customersResponse = await customersApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = customersResponse.data.map((c) => ({
        label: `${c.id} ${c.name}`,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'labSampleCode',
    label: 'labSampleId',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'lot',
    label: 'batch',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'orderSentAt',
    label: 'orderDate',
    type: 'dateDay',
  },
  {
    name: 'quarantineDate',
    label: 'quarantineDate',
    type: 'dateDay',
  },
  {
    name: 'date',
    label: 'lotDate',
    type: 'dateDay',
  },
  {
    name: 'productName',
    label: 'productName',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'orderId',
    label: 'orderNumber',
    type: 'text',
    whereOperator: '=',
  },
];

export default quarantineFilters;
